/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps, useFieldHelper } from 'framework/ui/field';
import {
  APPLICATIONS_STAGES,
  APPLICATIONS_STAGES_ORDER,
} from 'domain/recruiting/applications/shared/applicationService';
import { Box } from '@mui/material';

const ApplicationStageField = (props: FieldProps) => {
  const { getValue } = useFieldHelper(props);
  const activeStage = getValue();
  const i = APPLICATIONS_STAGES_ORDER.findIndex(stage => stage === activeStage);

  return (
    <>
      <EnumField options={APPLICATIONS_STAGES} {...props} />
      <Box sx={{ display: 'flex', marginTop: '2px' }}>
        {APPLICATIONS_STAGES_ORDER.map((stage, index) => {
          const backgroundColor = index < i ? 'success.main' : index === i ? 'info.dark' : 'text.secondary';

          return (
            <Box
              key={stage}
              sx={{
                width: '9px',
                height: '9px',
                backgroundColor,
                borderRadius: '50%',
                marginRight: '2px',
                position: 'relative',
                '&:not(:last-child)::after': {
                  content: "''",
                  height: '2px',
                  width: '2px',
                  right: 0,
                  top: '50%',
                  position: 'absolute',
                  backgroundColor,
                  transform: 'translate(100%, -50%)',
                },
              }}
            />
          );
        })}
      </Box>
    </>
  );
};

export default ApplicationStageField;
